import { defineComponent, PropType } from 'vue'

export const DividerPropValues = {
  height: { px: 'h-px', 2: 'h-2' },
}

export const Divider = defineComponent({
  props: {
    /** String as PropType<> 으로 잡으면 2 를 입력했을때 string 이 아니라고 vue warning 이 뜸. (StringConstructor 로 설정해뒀기 때문.) */
    height: {
      type: null as unknown as PropType<
        keyof typeof DividerPropValues['height']
      >,
      default: 'px',
    },
    text: { type: String },
    color: {
      type: String,
      default: '#f5f6f8',
    },
  },
  setup (props) {
    return () => {
      const { height: h, text } = props
      const height = DividerPropValues.height[h]
      return (
        <div class="flex items-center">
          <div
            class={`${height} flex-1`}
            style={{ backgroundColor: props.color }}
          />
          {text && <p class="text-[#898989] mx-4 select-none">{text}</p>}
          {text && (
            <div
              class={`${height} flex-1`}
              style={{ backgroundColor: props.color }}
            />
          )}
        </div>
      )
    }
  },
})
